<template>
    <div>
        <div v-if="tasks">
            <Grid
                v-if="tasks.length"
                :columns="computedColumns"
                :data="tasks"
                :page-length="parseInt(pageLength)"
                :total-rows-count="totalRowsCount"
                :sort="sort"
                :currentPage="currentPage"
                v-on:changePage="changePage"
                v-on:action="gridAction"
            >
            </Grid>

            <template v-else>
                <div class="py-4 text-center">
                    <h4 class="heading4 mb-4">Create a Task</h4>
                    <p class="mb-4">Assign tasks to teammates (or yourself) to keep track of action items</p>
                    <b-button variant="primary" size="lg" @click="addTask">+ Add Task</b-button>
                </div>
            </template>
        </div>
        <div v-else class="dashboard__placeholder">
        </div>

        <edit-task
            v-if="$store.state.canLoadGlobalComponents"
            ref="editTask"
            prefix="-edit"
            :startup-id="startupId"
        >
        </edit-task>
    </div>
</template>

<script>
import Grid from "@/components/Grid";
import grid from "@/mixins/grid";
import tasks from "@/services/tasks.service"

export default {
    props: {
        listType: {
            type: String,
            default: '',
        },

        startupId: {
            type: Number,
            default: 0,
        },

        trackerId: {
            type: Number,
            default: 0,
        },

        search: {
            type: String,
            default: "",
        },

        showCompleted: {
            type: Boolean,
            default: false,
        }
    },

    components: {
        Grid,
        EditTask: () => import("@/components/tasks/EditTask"),
    },

    mixins: [grid],

    data() {
        return {
            pageLength : 5,
            tasks: null,
            tasksLoaded: false,
        }
    },

    watch: {
        listType() {
            this.getList()
        },

        search() {
            this.getList()
        },

        showCompleted() {
            this.getList()
        },
    },

    computed: {
        computedColumns() {
            let columns = [
                {
                    name: 'title',
                    label: 'Title',
                    component: 'InlineEdit',
                },
                {
                    name: 'due',
                    label: 'Due',
                    component: 'RawColumn',
                },
                {
                    name: 'assignee',
                    label: 'Assignee',
                    component: 'RawColumn',
                },
            ]

            if (!this.startupId && !this.trackerId) {
                columns.push({
                    name: 'object',
                    label: 'Startup / Tracker',
                    component: 'RawColumn',
                })
            }

            columns.push({
                name: 'status',
                label: 'Status',
                component: 'StatusColumn',
            })

            columns.push({
                name: 'actions',
                component: 'Actions',
            })

            return columns
        }
    },

    mounted() {
        this.getList()

        this.$store.watch(state => {
            if (state.needUpdateTasks) {
                this.getList()
            }
        })
    },

    methods: {
        getList(forExport = false) {
            if (this.listType) {
                let currentPage = this.currentPage
                let pageLength = this.pageLength
                let search = this.search
                let showCompleted = this.showCompleted

                tasks.getIndex(this.listType, this.startupId, this.trackerId, {
                    forExport,
                    search,
                    showCompleted,
                    currentPage,
                    pageLength
                }).then(response => {
                    if (!this.tasksLoaded) {
                        this.tasksLoaded = true
                        this.$emit('loaded')
                    }

                    if (!forExport) {
                        this.tasks = response.data.data
                        this.totalRowsCount = parseInt(response.data.total_count)
                        this.currentPage = response.data.current_page
                    } else {
                        this.fileHelper.download(response.data, 'tasks.csv')
                    }
                })
            }
        },

        changePage(page) {
            this.currentPage = page
            this.getList()
        },

        exportCSV() {
            this.getList(true)
        },

        gridAction(params) {
            if (params.action == 'change-status') {
                let status = params.status
                tasks.update(params.rowId, {status: status}).then(() => {
                    this.getList()
                })
            }

            else if (params.action == 'edit') {
                this.editTask(params.rowId)
            }

            else if (params.action == 'delete') {
                if (confirm('Remove task?')) {
                    tasks.delete(params.rowId).then(() => {
                        this.getList()

                        this.$store.commit('setNeedUpdateTasks', true);

                        this.$nextTick(() => {
                            this.$store.commit('setNeedUpdateTasks', false);
                        })
                    })
                }
            }

            else if (params.action == 'value-changed') {
                tasks.update(params.rowId, {title: params.value}).then(() => {
                    this.getList()
                })
            }
        },

        editTask(id) {
            this.$refs.editTask.open(id)
        },

        addTask() {
            this.$refs.editTask.open()
        }
    }
}
</script>

<style scoped>

</style>